import React, { Component } from "react";
import { Link } from "react-router-dom";
import NavBar from "../components/navBar";
import carrerService from "../services/carrerService";
import {
  getCampaignReferrer,
  setCampaignReferrer,
  getUrlParameter,
} from "../utils/referrer";
import MessageModal from "../components/modals/messageModal";
import ScrollTop from "../components/scroll-top/scrollTop";
import Footer from "../components/footer";
import Metatags from "../components/metatags";

const initialState = {
  seletiveProcess: [],
  isLoading: true,
  requestError: false,
};

class Vagas extends Component {
  constructor(props) {
    super(props);
    this.state = initialState;
  }

  componentDidMount() {
    this.getSeletiveProcess();

    // verifica se chegou na pagina a partir de uma fonte de divulgacao
    const utmCampaign = getCampaignReferrer();
    if (!utmCampaign) {
      const campaignName = getUrlParameter("utm_campaign");
      const campaignSource = getUrlParameter("utm_source");
      const campaignMedium = getUrlParameter("utm_medium");
      const campaignTerm = getUrlParameter("utm_term");
      const campaignContent = getUrlParameter("utm_content");
      if (campaignName && campaignSource) {
        const utmParams = {
          name: campaignName,
          source: campaignSource,
          medium: campaignMedium,
          term: campaignTerm,
          content: campaignContent,
        };
        setCampaignReferrer(utmParams);
      }
    }
  }

  async getSeletiveProcess() {
    try {
      const sps = await carrerService.getSelectiveProcess();
      this.setState({ isLoading: false, seletiveProcess: sps });
    } catch {
      this.setState({ ...initialState, requestError: true });
    }
  }

  handleClickModalError = () => {
    this.setState({ requestError: false });
  };

  render() {
    const { isLoading, seletiveProcess, requestError } = this.state;

    return (
      <>
        <Metatags
          title="Vagas | LEVTY"
          description="Estamos sempre à procura de pessoas talentosas para expandir nossa equipe. Você pode se candidatar nas vagas abertas ou enviar seu currículo para oportunidades futuras."
          url={window.location.href}
          canonical="/vagas"
        />
        <NavBar />
        <main>
          <section className="notranslate opportunitiesSection" id="start">
            <div translate="no" className="notranslate container">
              <div
                translate="no"
                className="notranslate row justify-content-between"
              >
                <div
                  translate="no"
                  className="notranslate col-lg-4 mb-4 mb-lg-0"
                >
                  <h1 translate="no" className="notranslate h1 mb-3 mb-lg-4">
                    Vagas abertas
                  </h1>
                  <div translate="no" className="notranslate lead">
                    <p>
                      Estamos sempre à procura de pessoas talentosas para
                      expandir nossa equipe.
                    </p>
                    <p>
                      Você pode se candidatar nas vagas abertas ou enviar seu
                      currículo para oportunidades futuras.
                    </p>
                  </div>
                </div>
                {!isLoading ? (
                  <div
                    translate="no"
                    className="notranslate col-lg-7 animated fadeIn slow"
                  >
                    <div   translate="no" className="notranslate card lev-card-trainee mb-4">
                      <div   translate="no" className="notranslate row">
                        <div   translate="no" className="notranslate col-xl-7">
                          <div   translate="no" className="notranslate card-body">
                            <h2   translate="no" className="notranslate h4 card-title">Trainee 2025</h2>
                            <p   translate="no" className="notranslate card-text">Viva uma oportunidade única de se desenvolver. Buscamos as melhores condições para garantir que você evolua a sua carreira.</p>
                            <a   translate="no" className="notranslate btn btn-sm btn-primary" href="/carreiras/trainee">Venha conhecer</a>
                          </div>
                        </div>
                      </div>
                    </div>                    

                    <div translate="no" className="notranslate mb-4">
                      <div translate="no" className="notranslate lev-card-list">
                        {seletiveProcess && seletiveProcess.length !== 0 ? (
                          Object.keys(seletiveProcess).map((city, index) => {
                            return (
                              <div translate="no" key={index}>
                                <span
                                  translate="no"
                                  className="notranslate badge badge-primary mb-2"
                                >
                                  {city}
                                </span>

                                {Object.values(seletiveProcess)[index].map(
                                  (item) => {
                                    // const pathItemName = item.name.replace(/\s+/g, '-').toLowerCase();
                                    // const pathCity = city.replace(/\s+/g, '-').toLowerCase();
                                    // const pathState = seletiveProcess[city].city.state.initials.toLowerCase();

                                    return (
                                      <div translate="no" key={item._id}>
                                        <Link
                                          className="notranslate card mb-2"
                                          to={`/carreiras/vaga-${item.nameForUrl}-${item._id}`}
                                        >
                                          <div
                                            translate="no"
                                            className="notranslate card-body p-4"
                                          >
                                            <span
                                              translate="no"
                                              className="notranslate row justify-content-sm-between align-items-sm-center"
                                            >
                                              <span
                                                translate="no"
                                                className="notranslate col-sm-8 mb-1 mb-sm-0"
                                              >
                                                {item.name}
                                              </span>
                                              <span
                                                translate="no"
                                                className="notranslate col-sm-4 text-sm-right font-weight-bold"
                                              >
                                                {item.quantity}{" "}
                                                {item.quantity !== 1
                                                  ? "Vagas"
                                                  : "Vaga"}
                                              </span>
                                            </span>
                                          </div>
                                        </Link>
                                      </div>
                                    );
                                  }
                                )}
                              </div>
                            );
                          })
                        ) : (
                          <div
                            translate="no"
                            className="notranslate lev-nenhuma-vaga"
                          >
                            {/* <img src={process.env.PUBLIC_URL + "images/illustrations/cryingFace.png"} alt="LEVTY" /> */}
                            <h2>Nenhum processo seletivo aberto no momento</h2>
                          </div>
                        )}
                      </div>
                    </div>

                    <div   translate="no" className="notranslate card lev-card-talent">
                      <div   translate="no" className="notranslate row">
                        <div   translate="no" className="notranslate col-xl-8">
                          <div   translate="no" className="notranslate card-body">
                            <h2   translate="no" className="notranslate h4 card-title">Mostre seu talento</h2>
                            <p   translate="no" className="notranslate card-text"> Cadastre seu currículo. Se houver alguma vaga compatível com o seu perfil, vamos entrar em contato com você.</p>
                            <a   translate="no" className="notranslate btn btn-sm btn-primary" href="talento">Cadastre-se</a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <>
                    <div translate="no" className="notranslate col-lg-4">
                      <div translate="no" className={"lev-loading-test"}></div>
                    </div>
                  </>
                )}
              </div>
            </div>
            <span
              translate="no"
              className="notranslate lev-section-jobs-bg"
            ></span>
          </section>
        </main>
        <ScrollTop />
        <Footer />
        {requestError && (
          <MessageModal
            title="Oops!"
            subtitle="Erro ao obter as vagas em aberto, tente novamente mais tarde"
            buttonClass="danger"
            onClick={this.handleClickModalError}
          />
        )}
      </>
    );
  }
}

export default Vagas;
